/* lcs-headings-blog.js — Blog listing headings (one H1 + UI demote)
 *
 * 2026-09-17 (ffdm, Website 3.0). Three changes to the original:
 *
 *  1. If the template marks its own title with [data-w3-page-title], that IS the
 *     page's H1 and nothing else is promoted. The W3 blog template does this, so
 *     a topic archive gets the topic's name as its H1 rather than the old
 *     "Welcome To Our Blog" banner. Without the marker the old behaviour is kept.
 *  2. The UI demotion no longer matches a bare `header`. It was matching the
 *     <header> element inside the listing itself.
 *  3. DEBUG off by default.
 */
(function () {
  var DEBUG = false;
  function log(){ if(DEBUG && window.console) try{ console.log.apply(console,arguments);}catch(_){} }

  /* ---------- Utils ---------- */
  function currentTemplate(){
    var b=document.body;
    var m=(b.className.match(/template-([a-z0-9\-.]+)/i)||[])[1]||'';
    var dt=b.getAttribute('data-template')||document.documentElement.getAttribute('data-template')||'';
    return (dt||m||'').toLowerCase();
  }
  function blogHandle(){
    var p=(window.location.pathname||'').split('/').filter(Boolean);
    return (p[0]==='blogs' && p[1]) ? p[1].toLowerCase() : '';
  }
  function isBlogList(){
    var tpl = currentTemplate();
    var isBlog = tpl.indexOf('blog')===0 && tpl.indexOf('article')===-1;
    var h = blogHandle();
    return isBlog && !!h;
  }
  if(!isBlogList()){ log('[LCS-BLOG] Skip — template:', currentTemplate(), 'path:', location.pathname); return; }
  log('[LCS-BLOG] Running on', currentTemplate(), 'handle:', blogHandle());

  /* ---------- helpers ---------- */
  function toPresentational(el){
    if(!el || !/^H[1-6]$/i.test(el.tagName)) return;
    if(el.hasAttribute('data-w3-page-title')) return;   // never demote the marked title
    try{
      var d=document.createElement('div');
      for(var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; d.setAttribute(a.name,a.value); }
      d.className=(d.className?d.className+' ':'')+'ui-heading';
      d.setAttribute('role','presentation'); d.setAttribute('aria-hidden','true');
      while(el.firstChild) d.appendChild(el.firstChild);
      el.replaceWith(d);
      log('[LCS-BLOG] Demoted', el.tagName, '→ DIV', (d.className||''));
    }catch(e){ /* noop */ }
  }
  function retagKeepStyles(el,tag){
    if(!el || el.tagName.toLowerCase()===tag) return el;
    var n=document.createElement(tag);
    for(var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; n.setAttribute(a.name,a.value); }
    while(el.firstChild) n.appendChild(el.firstChild);
    el.replaceWith(n);
    return n;
  }
  function unhide(el){
    if(!el) return el;
    el.removeAttribute('role');
    el.removeAttribute('aria-hidden');
    if(el.classList) el.classList.remove('ui-heading');
    return el;
  }

  /* ---------- 1) Demote UI headings (site chrome, drawers, modals, search) ---------- */
  var UI_SCOPES=[
    '#shopify-section-header','body > header','header[role="banner"]','.site-header',
    '.drawer','.modal','.modal__content',
    '.cart-drawer','#CartDrawer','.cart-notification','#CartNotification','.ajaxcart','.mini-cart',
    '.predictive-search','[data-predictive-search]',
    '.quick-add','.quickshop','.product-quickshop','#dialogQuickShopTitle'
  ];
  var UI_SELECTOR=UI_SCOPES.map(function(s){return s+' h1,'+s+' h2,'+s+' h3,'+s+' h4,'+s+' h5,'+s+' h6';}).join(',');
  function fixUI(root){
    (root||document).querySelectorAll(UI_SELECTOR).forEach(toPresentational);
  }

  /* ---------- 2) Empty headings → presentational ---------- */
  function fixEmpty(root){
    (root||document).querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var t=(h.textContent||'').replace(/\s+/g,'').trim();
      if(!t.length) toPresentational(h);
    });
  }

  /* ---------- 3) The page title ---------- */
  function fixHero(){
    var marked=document.querySelector('[data-w3-page-title]');
    var title=null;

    if(marked){
      title=unhide(marked);
    }else{
      var hero=document.querySelector('.s-header, .banner, [data-section-type*="banner"], .hero');
      if(!hero) return;
      var nodes=hero.querySelectorAll('h1,h2,h3,.s-header__title,.s-header__heading');
      nodes.forEach(function(n){
        var tx=(n.textContent||'').trim().toLowerCase();
        if(!title && /welcome.*blog/.test(tx)) title=n;
      });
      if(!title) title=hero.querySelector('.s-header__title, h1, h2');
    }

    if(title){
      title=retagKeepStyles(title,'h1');
      title.id='page-title';
      title.setAttribute('aria-level','1');
      log('[LCS-BLOG] Title → H1', marked ? '(marked)' : '(fallback)');
    }

    // One H1 only, inside <main>.
    var main=document.querySelector('main')||document;
    var canonical=document.getElementById('page-title');
    main.querySelectorAll('h1').forEach(function(h){
      if(canonical && h!==canonical) retagKeepStyles(h,'h2');
    });
  }

  /* ---------- 4) Section and UI label cleanup ---------- */
  function fixSections(){
    var DECOR_RX=/^(cart|menu|quick\s*shop)$/i;
    document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var tx=(h.textContent||'').trim().toLowerCase().replace(/\s+/g,' ');
      if(DECOR_RX.test(tx)) toPresentational(h);
    });

    // Legacy blog template: keep this subtitle an H2 if it is mistagged.
    var sub = [].slice.call(document.querySelectorAll('h1,h2,h3,h4,.section-title,.title')).find(function(n){
      var t=(n.textContent||'').trim().toLowerCase();
      return t==='hungry for inspiration or tips?' || /hungry.*tips\??$/.test(t);
    });
    if(sub) retagKeepStyles(sub,'h2');
  }

  /* ---------- run & observe ---------- */
  function run(){ fixUI(); fixEmpty(); fixHero(); fixSections(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  new MutationObserver(function(m){
    m.forEach(function(x){
      (x.addedNodes||[]).forEach(function(n){
        if(n && n.nodeType===1){ fixUI(n); fixEmpty(n); fixHero(); fixSections(); }
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
